import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Landing } from './pages/Landing';
import { Auth } from './pages/Auth';
import { Analysis } from './pages/Analysis';
import { BrokerDashboard } from './pages/BrokerDashboard';
import { CompanyDashboard } from './pages/CompanyDashboard';
import { CRM } from './pages/CRM';
import { Bookmarks } from './pages/Bookmarks';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route
              path="/broker/dashboard"
              element={
                <ProtectedRoute allowedRoles={['broker']}>
                  <BrokerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/broker/crm"
              element={
                <ProtectedRoute allowedRoles={['broker']}>
                  <CRM />
                </ProtectedRoute>
              }
            />
            <Route
              path="/broker/bookmarks"
              element={
                <ProtectedRoute allowedRoles={['broker']}>
                  <Bookmarks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/company/dashboard"
              element={
                <ProtectedRoute allowedRoles={['company']}>
                  <CompanyDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster
            theme="light"
            position="top-right"
            toastOptions={{
              style: {
                background: '#FFFFFF',
                color: '#0F172A',
                border: '1px solid #E2E8F0',
              },
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
